import { UserDTO } from './UserDTO';
import { Utils } from '../utils/utils';
import { KeyDriversDTO } from './KeyDriversDTO';
import { Serializable } from './Serializable';

export class CommentResumeDTO extends Serializable {

    deliverySurveyItemQuestionId: string;
    titleFeedback: string;
    responseOn: string;
    keyDriverTitle: string;
    userImage: string;
    userFullName: string;
    score: number;
    feedback: string;
    isAnonymous: boolean;
    ownerImage: string;
    ownerFullName: string;
    response: string;

    constructor() {
        super();
    }

    get dateResponse() {
        let dateResponse = "";
        let date = new Date(this.responseOn);
        dateResponse = Utils.dateToString(date).replace(/-/g, "/");
        return dateResponse;
    }

}